import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import useStyles from './style';

const formatDateTime = (d) => {
  if (!d) return '-';
  try {
    return new Date(d).toLocaleString('pt-BR');
  } catch (_) {
    return '-';
  }
};

const formatDuracao = (segundos) => {
  if (segundos === null || segundos === undefined) return '-';
  const s = Number(segundos);
  if (Number.isNaN(s)) return '-';
  if (s < 60) return `${s.toFixed(1)}s`;
  const m = Math.floor(s / 60);
  const r = Math.round(s - m * 60);
  return `${m}m ${r}s`;
};

// Modal so-visualizacao com detalhes completos da execucao. Auditoria e imutavel,
// entao nao expomos acoes de retry/delete aqui.
export default function ExecucaoDetalhesModal({ open, execucao, onClose }) {
  const classes = useStyles();

  if (!open || !execucao) {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Detalhes da Execução</DialogTitle>
        <DialogContent>
          <div className={classes.modalBody}>Nenhuma execução selecionada.</div>
        </DialogContent>
        <DialogActions>
          <button className={classes.buttonAction} onClick={onClose}>
            Fechar
          </button>
        </DialogActions>
      </Dialog>
    );
  }

  const {
    importacaoTituloExecucaoId,
    apelidoAncora,
    apelidoVinculo,
    erp,
    tipo,
    origem,
    status,
    dataInicio,
    dataFim,
    duracaoSegundos,
    qtdDuplicatas,
    qtdFornecedores,
    arquivoGerado,
    mensagemAvisos,
    mensagemErro,
  } = execucao;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Detalhes da Execução #{importacaoTituloExecucaoId}</DialogTitle>
      <DialogContent>
        <div className={classes.modalBody}>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Rede:</span>
            <span>{apelidoAncora || '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Vínculo:</span>
            <span>{apelidoVinculo || '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>ERP:</span>
            <span>{erp || '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Tipo:</span>
            <span>{tipo || '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Origem:</span>
            <span>{origem || '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Status:</span>
            <span>{status || '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Início:</span>
            <span>{formatDateTime(dataInicio)}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Fim:</span>
            <span>{formatDateTime(dataFim)}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Duração:</span>
            <span>{formatDuracao(duracaoSegundos)}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Duplicatas:</span>
            <span>{qtdDuplicatas ?? '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Fornecedores:</span>
            <span>{qtdFornecedores ?? '-'}</span>
          </div>
          <div className={classes.modalRow}>
            <span className={classes.modalLabel}>Arquivo gerado:</span>
            <span style={{ wordBreak: 'break-all', textAlign: 'right' }}>
              {arquivoGerado || '-'}
            </span>
          </div>

          {mensagemAvisos ? (
            <div style={{ marginTop: '12px' }}>
              <span className={classes.modalLabel}>Avisos:</span>
              <pre className={classes.modalPre}>{mensagemAvisos}</pre>
            </div>
          ) : null}

          {mensagemErro ? (
            <div style={{ marginTop: '12px' }}>
              <span className={classes.modalLabel}>Mensagem de erro:</span>
              <pre className={classes.modalPre}>{mensagemErro}</pre>
            </div>
          ) : null}
        </div>
      </DialogContent>
      <DialogActions>
        <button className={classes.buttonAction} onClick={onClose}>
          Fechar
        </button>
      </DialogActions>
    </Dialog>
  );
}
